// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__QwD+f","footerText":"Footer_footerText__HLuh1"};